var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;fill-rule:evenodd;}.b{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.5,17a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Zm0-2a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1ZM21,13v1H3V13ZM14,5V8a4.25,4.25,0,0,1-4,0V5Zm6-1a1.591,1.591,0,0,0-1.5-1H5.5A1.6,1.6,0,0,0,4,4L3,13v7H4v1a.884.884,0,0,0,1,1H6a1,1,0,0,0,1-1V20H17v1a1,1,0,0,0,1,1h1a.884.884,0,0,0,1-1V20h1V13ZM5,19.64a.5.5,0,0,1,.121.015l1,.25a.5.5,0,0,1,.379.485V21a.5.5,0,0,1-.5.5H5a.5.5,0,0,1-.5-.5v-.86A.5.5,0,0,1,5,19.64Zm14.485.379a.5.5,0,0,1,.015.121V21a.5.5,0,0,1-.5.5H18a.5.5,0,0,1-.5-.5v-.61a.5.5,0,0,1,.379-.485l1-.25A.5.5,0,0,1,19.485,20.019ZM5.5,18A1.5,1.5,0,1,1,7,16.5,1.5,1.5,0,0,1,5.5,18Zm13,0A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,18.5,18ZM1.5,9a1,1,0,0,1,1,1v2L3,13H2a1,1,0,0,1-1-1V9ZM23,9v3a1,1,0,0,1-1,1H21l.5-1V10a1,1,0,0,1,1-1ZM19,4l.5,7.5q-5,.5-7.5.5t-7.5-.5L5,4ZM12,8a1,1,0,1,0-1-1A1,1,0,0,0,12,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.bd0dbd83b5cb65160474e004281694ff.svg";
export { ForwardRef as ReactComponent };